import { useMediaQuery } from 'react-responsive';
import styles from './healthcare-case3.module.css';
import Connect from '../../public/svg/connect.svg';
import ConnectMobile from '../../public/svg/connect-mobile.svg';
import Puzzle from '../../public/healthcare/case3/puzzle.svg';
import PuzzleMobile from '../../public/healthcare/case3/puzzle-mobile.svg';
import HealthcareBanner from './healthcare-banner';
import { useMounted } from '../../hooks';
import { Container } from '../../components';
import HealthcareDescription from './healthcare-description';

export default function HealthcareCase3() {
  const mounted = useMounted();
  const isTablet = useMediaQuery({ maxDeviceWidth: 1023 });

  return (
    <div className={styles.case3}>
      <Container>
        <div className={styles.case3_inner}>
          <HealthcareDescription
            title="Case #3"
            text="Use this app to see the meds prescribed and plan how to take them. Read the instructions to each drug with the explanation about its consist, recommendations and list of allergies."
          />
          {mounted && !isTablet ? (
            <Connect className={styles.case3_connect} />
          ) : (
            <ConnectMobile className={styles.case3_connectMobile} />
          )}
          <h4 className={styles.case3_title}>Meds Planner App</h4>
          {mounted && isTablet && (
            <ConnectMobile className={styles.case3_connectMobile} />
          )}

          {mounted && !isTablet && (
            <img
              alt="line"
              className={styles.case3_doubleConnect}
              src="svg/double-contect.svg"
            />
          )}

          <div className={styles.case3_wrapper}>
            <div className={styles.case3_wrapperStart}>
              <img src="healthcare/case3/screen1.webp" alt="decor" />
            </div>
            <div className={styles.case3_wrapperMiddle}>
              {mounted && !isTablet && <Puzzle />}
            </div>
            <div className={styles.case3_wrapperEnd}>
              <img src="healthcare/case3/screen2.webp" alt="decor" />
            </div>
          </div>

          {mounted && isTablet && (
            <PuzzleMobile className={styles.case3_puzzleMobile} />
          )}

          <div className={styles.case3_box}>
            <div className={styles.case3_boxStart}>
              {mounted && !isTablet && (
                <img src="healthcare/case3/arm-syringe.webp" alt="decor" />
              )}
            </div>
            <div className={styles.case3_boxMiddle}>
              <img src="healthcare/case3/screen3.webp" alt="decor" />
            </div>
            <div className={styles.case3_boxEnd}>
              {mounted && !isTablet && (
                <img src="healthcare/case3/arm-tablet.webp" alt="decor" />
              )}
            </div>
          </div>
          <HealthcareBanner
            className={styles.case3_banner}
            text="Have a Healthcare App in Mind?"
            href="/contact"
            btnLabel="Estimate my project"
          />
        </div>
      </Container>
    </div>
  );
}
